import React, { useRef, useEffect } from 'react';

export interface AutoGrowTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  showCount?: boolean;
}

export const AutoGrowTextarea = React.forwardRef<HTMLTextAreaElement, AutoGrowTextareaProps>(
  ({ className, showCount, ...props }, ref) => {
    const internalRef = useRef<HTMLTextAreaElement>(null);
    const textareaRef = (ref as React.MutableRefObject<HTMLTextAreaElement>) || internalRef;

    const adjustHeight = () => {
      const textarea = textareaRef.current;
      if (textarea) {
        textarea.style.height = 'auto';
        // min-height of ~2 lines (~48px), max-height ~10-12 lines (~240px)
        textarea.style.height = `${Math.min(Math.max(textarea.scrollHeight, 48), 240)}px`;
      }
    };

    useEffect(() => {
      adjustHeight();
    }, [props.value]);

    const val = props.value ? String(props.value) : '';
    const charCount = val.length;
    const wordCount = val.trim() ? val.trim().split(/\s+/).length : 0;

    return (
      <div className="relative w-full group">
        <textarea
          {...props}
          ref={textareaRef}
          onChange={(e) => {
            if (props.onChange) props.onChange(e);
            adjustHeight();
          }}
          className={`w-full px-3 py-2.5 text-xs border border-ink-200 rounded-xl bg-white font-sans focus:border-brand-500 focus:ring-4 focus:ring-brand-500/10 outline-none transition-all resize-none placeholder-gray-400 ${
            className || ''
          }`}
        />
        {showCount && (
          <div className="absolute bottom-2 right-2 text-[9px] text-ink-400 font-sans pointer-events-none bg-white/80 px-1 rounded">
            {charCount} chars • {wordCount} words
          </div>
        )}
      </div>
    );
  }
);
AutoGrowTextarea.displayName = 'AutoGrowTextarea';
